var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseModal',{ref:"BaseModal",staticClass:"full-modal",on:{"confirm":_vm.confirm,"close":_vm.close}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }